const IconChurch = () => {
    return (
        <svg
            width="47"
            height="47"
            viewBox="0 0 47 47"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M35.2498 24.91V18.6042L25.4582 13.7083V10.7708H29.3748V6.85417H25.4582V2.9375H21.5415V6.85417H17.6248V10.7708H21.5415V13.7083L11.7498 18.6042V24.91L3.9165 28.3958V44.0625H21.5415V36.2292C21.5415 35.1521 22.4228 34.2708 23.4998 34.2708C24.5769 34.2708 25.4582 35.1521 25.4582 36.2292V44.0625H43.0832V28.3958L35.2498 24.91ZM39.1665 40.1458H29.3748V36.1508C29.3748 32.8412 26.7311 30.1583 23.4998 30.1583C20.2686 30.1583 17.6248 32.8412 17.6248 36.1508V40.1458H7.83317V30.7654L15.6665 27.2208V20.6604L23.4998 16.6458L31.3332 20.6408V27.2013L39.1665 30.7458V40.1458Z"
                fill="currentColor"
            />
            <path
                d="M23.4998 27.4167C25.1222 27.4167 26.4373 26.1015 26.4373 24.4792C26.4373 22.8568 25.1222 21.5417 23.4998 21.5417C21.8775 21.5417 20.5623 22.8568 20.5623 24.4792C20.5623 26.1015 21.8775 27.4167 23.4998 27.4167Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default IconChurch;
